<script>
import { inView } from '../../../../common/util';
import store from '../store/index.js';
export default {
    data() {
        return {
            isShowSubmit: false
        }
    },
    methods: {
        submitClick($event) {
            this.$emit('click', 'middle-button-click')
        }
    },
    computed: {
        isShowCoupon() {
            return store.isShowCoupon;
        },
		couponValue() {
            return store.couponValue;
        }
    },
    mounted() {
        window.addEventListener('scroll', () => {
			if (inView(document.querySelector('.js-submit'))) {
                if (this.isShowSubmit) {
                    return;
                }
                this.isShowSubmit = true;
                this.$clickMonitor.send({
                    buttonId: 'middle-button-show',
                    ...store.getClickMonitorParams()
                });
            }
		});
        // if (inView(document.querySelector('.js-submit'))) {
        //     if (this.isShowSubmit) {
        //         return;
        //     }
        //     this.isShowSubmit = true;
        //     this.$clickMonitor.send({
        //         buttonId: 'middle-button-show',
        //         ...store.getClickMonitorParams()
        //     });
        // }
    },
}
</script>
<template>
    <div id="submit" class="submit js-submit" @click="submitClick()">
        <div v-show="isShowCoupon">
            <p class="submit-text">免费预约咨询</p>
            <p class="submit-text-sub">送{{couponValue}}元到店打车券</p>
        </div>
        <div v-show="!isShowCoupon">
             <p class="submit-text-center">免费预约咨询</p>
        </div>
    </div>
</template>

<style lang="stylus" scoped>
.submit
    height:3.04rem;
    background:linear-gradient(144deg,rgba(250,217,97,1) 0%,rgba(247,107,28,1) 100%);
    border-radius:1.52rem;
    margin 1.17rem 0 0
    text-align center
    font-size 0.853rem
    background-color #FF3C00
    color #fff
    cursor pointer
    .submit-text
        padding-top: .25rem;
        font-size:1.07rem;
    .submit-text-sub
        font-size:0.75rem;
    .submit-text-center
        line-height 3.04rem;
</style>